module.exports = __webpack_public_path__ + "static/media/Regina.9051cf9f.jpeg";